// @flow
import { isEmpty } from "../../utils/lodashExtend";
import {
  GET_EMPLOYEES,
  GET_EMPLOYEES_SUCCESS,
  GET_PARTS,
  GET_PARTS_SUCCESS,
  API_ERROR,
  GET_COMPANIES,
  GET_COMPANIES_SUCCESS,
  GET_GRADES,
  GET_GRADES_SUCCESS,
  GET_GROUPS,
  GET_GROUPS_SUCCESS,
  FULL_SIZE_LOADING,
  ALERT,
  GET_CARE_COMPANIES_SUCCESS,
  GET_UNREAD_NOTIFICATION_COUNT_SUCCESS,
  GET_UNREAD_NOTIFICATION_COUNT,
  CONSULTING,
  TRIAL,
  TRIAL_REQUEST_PARTNERS,
  PRINT_PAGE,
  TAX_ACCOUNTANT_USEFUL_SITE,
  GET_TAXPAYER_LIST_SUCCESS,
  CMS_REGISTRATION,
  POPUP_TOGGLE,
} from "./actionTypes";

const INIT_STATE = {
  myCompany: null, // 관리 회사로 접근했을때 내 회사 정보
  employees: [], // 사용자 현 회사의 직원 정보
  myRoleEmployees: [], // 내가 접근 가능한 직원
  myRoleEmployeesIdx: [], // 내가 접근 가능한 직원 IDX
  isEmployeesLoading: false,
  parts: [], // 사용자 현 회사의 part 정보
  myRoleParts: [],
  myRolePartsIdx: [],
  isPartsLoading: false, // part 정보 로딩
  companies: [], // 사용자의 컴파니 리스트
  careCompanies: [], // 내가 담당하는 회사 목록
  grades: [], // 사용자의 직급 리스트
  isGradesLoading: false,
  groups: [], // 사용자의 그룹 리스트
  isGroupsLoading: false,
  error: "", // 해당 스토어에서 사용되는 api 에러가 있을 경우 error 표기
  isFullSizeLoading: false, // loading 유틸을 통해 Boolean 값 저장 로딩 화면 노출
  alert: null, // systemAlert 유틸을 통해 Object or nulll 값 저장  알럿 노출
  ceos: [], // 회사 대표
  financeManagers: [], // 회사 경리
  unreadNotificationCount: 0, // 읽지 않은 노티 수
  isConsultingPopup: false, // 문의하기 팝업
  taxAccountantUsefulSite: false, // 세무사 유용한 사이트
  managerEmployees: [], // 세무회사의 직원정보(세무회사 직원만 가능)
  taxpayerList: [], // 수임처 목록(세무회사 직원만 가능)
  popupToggle: false,
};

const data = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EMPLOYEES:
      return {
        ...state,
        isEmployeesLoading: true,
      };
    case GET_EMPLOYEES_SUCCESS:
      return {
        ...state,
        isEmployeesLoading: false,
        employees: action.payload.employees,
        myRoleEmployees: action.payload.myRoleEmployees,
        myRoleEmployeesIdx: action.payload.myRoleEmployeesIdx,
        ceos: action.payload.ceos,
        financeManagers: action.payload.financeManagers,
        managerEmployees: action.payload.managerEmployees,
      };
    case GET_PARTS:
      return {
        ...state,
        isPartsLoading: true,
      };
    case GET_PARTS_SUCCESS:
      return {
        ...state,
        parts: action.payload.parts,
        myRoleParts: action.payload.myRoleParts,
        myRolePartsIdx: action.payload.myRolePartsIdx,
        managerParts: action.payload.managerParts,
        isPartsLoading: false,
      };
    case GET_COMPANIES:
      return {
        ...state,
        isPartsLoading: true,
      };
    case GET_COMPANIES_SUCCESS:
      return {
        ...state,
        isPartsLoading: false,
        companies: action.payload,
      };
    case GET_CARE_COMPANIES_SUCCESS:

      const careCompanies = action.payload;
      const result = {
        ...state,
        careCompanies,
      };
      if (!isEmpty(careCompanies)) result.myCompany = careCompanies[0];
      return result;
    case GET_GRADES:
      return {
        ...state,
        isGradesLoading: true,
      };
    case GET_GRADES_SUCCESS:
      return {
        ...state,
        isGradesLoading: false,
        grades: action.payload.grades,
        managerGrades: action.payload.managerGrades,
      };
    case GET_GROUPS:
      return {
        ...state,
        isGroupsLoading: true,
      };
    case GET_GROUPS_SUCCESS:
      return {
        ...state,
        isGroupsLoading: false,
        groups: action.payload.groups,
        managerGroups: action.payload.managerGroups
      };
    case GET_UNREAD_NOTIFICATION_COUNT:
      return {
        ...state,
      };
    case GET_UNREAD_NOTIFICATION_COUNT_SUCCESS:
      return {
        ...state,
        unreadNotificationCount: action.payload,
      };
    case API_ERROR:
      return {
        ...state,
        isPartsLoading: false,
        isEmployeesLoading: false,
        error: action.payload,
      };
    case FULL_SIZE_LOADING:
      return {
        ...state,
        isFullSizeLoading: action.payload,
      };
    case ALERT:
      return {
        ...state,
        alert: action.payload,
      };
    case POPUP_TOGGLE:
      return {
        ...state,
        popupToggle: action.payload,
      };
    case TAX_ACCOUNTANT_USEFUL_SITE:
      return {
        ...state,
        taxAccountantUsefulSite: !state.taxAccountantUsefulSite,
      };
    case PRINT_PAGE:
      return {
        ...state,
        printPage: action.payload,
      };
    case TRIAL:
      return {
        ...state,
        trialType: action.payload,
      };
    case TRIAL_REQUEST_PARTNERS:
      return {
        ...state,
        isTrialRequestPartners: action.payload,
      };
    case CMS_REGISTRATION:
      return {
        ...state,
        isCmsRegistrationModal: action.payload,
      };
    case CONSULTING:
      return {
        ...state,
        isConsultingPopup: action.payload,
      };

    case GET_TAXPAYER_LIST_SUCCESS:
      return {
        ...state,
        taxpayerList: action.payload
      };
    default:
      return state;
  }
};

export default data;
